import React from "react";
import { useEffect, useState } from "react";
import { setGoHome, setLoader } from "../../action/homeAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import moment from "moment";
import { scrollToTop } from "../../../JS/scrollToTop";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { popupOpenClose } from "../../../action/action";


function Event1_ListEvents(props) {
    const { t } = props;
    // const [props.eventDataToBeRendered, props.setEventDataToBeRendered] = useState(null);
    // const [isAllFilterSelected, setIsAllFilterSelected] = useState(true);

    const handleNext = (event) => {
        // props.fetchMyReservations();
        props.setSelectedEvent(event)
        props.next();
    }

    // useEffect(()=>{
    //     console.log(props.selectedEventAndInventory,"selectedEventAndInventory")
    // })

    useEffect(()=>{
        if(props.availableEvents && props.availableEvents.length==1){
            handleNext(props.availableEvents[0])
        }
    },[props.availableEvents])

    useEffect(() => {
        scrollToTop();
        
        console.log("P1: props.availableEvents", props.availableEvents)
        // console.log("P1: props.selectedEventAndInventory", props.selectedEventAndInventory)
        // if (props.availableEvents) props.setEventDataToBeRendered(props.availableEvents)

    }, [])

    return (<>

        <header className="inner-pages w-footer subpages">
            <a className="button-back" onClick={props.back}></a>
            <div className="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
            </div>
        </header>


        <section className="widgets padding-0 margin-0 container-bg">

            <section class="widgets spa-listing">
                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl && (
                        <div class="widget-header-img">
                            <img
                                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                alt={props.currentWidgetObj.displayName}
                            />
                        </div>
                    )}

                    <div class="widget-header-title">{t(`events.heading1`)}</div>
                </div>

                <div class="row">
                    <div class="col sm-banner">
                        <div class="col sm-banner">
                            {
                                props.availableEvents &&
                                <>

                                    {
                                        props.availableEvents.length > 0
                                        ?
                                        props.availableEvents.map((event) => {

                                            let eventName = event.eventName;
                                            let eventId = event.eventId;
                                            let eventDesc = event.events[0].description;


                                            return (
                                                <a
                                                    id={eventId}
                                                    className={"tile-sm thumbnails tile-container"}
                                                    onClick={() => {
                                                        handleNext(event);
                                                    }}
                                                >
                                                    <div class="thumb-text">
                                                        <p class="thumb-heading">{eventName}</p>
                                                        <p class="thumb-description" dangerouslySetInnerHTML={{__html:eventDesc}} />
                                                    </div>
                                                </a>
                                            );
                                        })
                                        :
                                        <div>
                                            {t("events.error.no_events_found")}
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>

            </section>
        </section>

    </>

    )
}
const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : ""

    }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, popupOpenClose }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Event1_ListEvents));


     {/* 
        <section class="widgets spa-listing spa-details">
            <div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl && (
                    <div class="widget-header-img">
                        <img
                            src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                            alt={props.currentWidgetObj.displayName}
                        />
                    </div>
                )}

                <div class="widget-header-title">{t(`events.heading1`)}</div>
            </div>




            {props.eventDataToBeRendered
                ?
                (
                    props.eventDataToBeRendered.length > 0
                        ?
                        <>

                            <div class="tab-selection">
                                <ul class="tabs">
                                    <li>
                                        <a
                                            class={isAllFilterSelected ? "tab-selected" : ""}
                                            onClick={() => {
                                                setIsAllFilterSelected(true);
                                                props.setEventDataToBeRendered(props.availableEvents);
                                            }}
                                        >
                                            All
                                        </a>
                                    </li>
                                    {props.availableEvents.map((data, index) => {
                                        if(data.events[0].inventories.length>0){
                                            return (
                                                <li>
                                                    <a
                                                        class={
                                                            !isAllFilterSelected &&
                                                                props.eventDataToBeRendered &&
                                                                data.eventId == props.eventDataToBeRendered[0].eventId
                                                                ? "tab-selected"
                                                                : ""
                                                        }
                                                        onClick={() => {
                                                            setIsAllFilterSelected(false);
                                                            props.setEventDataToBeRendered([data]);
                                                        }}
                                                    >
                                                        {data.eventName}
                                                    </a>
                                                </li>
                                            );
                                        }
                                    })}
                                </ul>
                            </div>


                            <div class="row">
                                <div class="col">
                                    <div class="detail-body stay-body">
                                        <form>
                                            {
                                                props.eventDataToBeRendered.map((event, index) => {
                                                    
                                                    let eventName = event.eventName;
                                                    let eventId = event.eventId;
                                                    let uniqueEvent = event.events[0];
                                                    let eventDesc = event.events[0].description;
                                                    return uniqueEvent.inventories && uniqueEvent.inventories.length > 0
                                                        ?
                                                        (
                                                            <div
                                                                class="form-row"
                                                            >
                                                                <p class="heading">{`${eventName}`}</p>
                                                                <p class="subheading">{`${eventDesc}`}</p>
                                                                <div class="form-options">
                                                                    {uniqueEvent.inventories.map((inventory) => {
                                                                        return (
                                                                            <label
                                                                                class="radio-group"
                                                                                onClick={() => {
                                                                                    console.log("hello")
                                                                                    console.log({
                                                                                        eventName: eventName,
                                                                                        eventId: eventId,
                                                                                        inventory: inventory,
                                                                                        differentVenues:event.events
                                                                                    })
                                                                                    props.setSelectedEventAndInventory({
                                                                                        eventName: eventName,
                                                                                        eventId: eventId,
                                                                                        inventory: inventory,
                                                                                        differentVenues:event.events
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <input
                                                                                    type="radio"
                                                                                    name="Times"
                                                                                    // value={JSON.stringify(inventory)}
                                                                                    checked={
                                                                                        props.selectedEventAndInventory &&
                                                                                        inventory == props.selectedEventAndInventory.inventory
                                                                                    }
                                                                                />
                                                                                <div class="radio-content">
                                                                                    <p class="heading">{inventory.inventory_name}</p>
                                                                                   
                                                                                    <div class="options">
                                                                                         
                                                                                        <div class="amount">{`${props.currencyCode} ${inventory.price}`}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </label>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )
                                                        :
                                                        (<></>);
                                                })}
                                        </form>
                                    </div>
                                </div>
                            </div>



                        </>

                        :

                        <div>
                            {t("events.error.no_events_found")}
                        </div>

                )
                :
                <div>
                    {t("events.error.error")}
                </div>
            }


            <div class="row">
                <div class="form-controls">
                    <button 
                    disabled={!props.selectedEventAndInventory}
                    onClick={handleNext}>
                        {t("events.continue")}
                    </button>
                </div>
            </div>


        </section> */}

